<template>
  <div class="container-fluid bg-login">
    <div class="">
      <div class="login" style="padding-top: 25vh;">
        <div class="loginblock">
          <div class="head">
            <h1> {{ $t('switcher.header') | capitalize }}
            </h1>
          </div>
          <div class="content">
            <Loading :visible="loading" />
            <form accept-charset="UTF-8" id="form-login">
              <div class="fields">
                <div class="field">
                  <label for="tenant" style="margin: 0;">
                    {{ $t('switcher.tenant') | capitalize }}
                  </label>
                  <select name="tenant"
                          class="tenant-select"
                          v-model="selectedTenantId"
                  >
                    <option v-for="tenant in tenants"
                            :value="tenant.id"
                            :key="tenant.id"
                    >
                      {{ tenant.name }}
                    </option>
                  </select>
                </div>
                <div class="field">
                  <label for="network" style="margin: 0;">
                    {{ $t('switcher.network') | capitalize }}
                  </label>
                  <select :disabled="networks_disabled"
                          style="width: 100%"
                          size="large"
                          v-model="selectedNetworkId"
                  >
                    <option v-for="network in networks"
                            :value="network.id"
                            :key="network.id"
                    >
                      {{ network.name }}
                    </option>
                  </select>
                </div>
                <div class="field buttonfield">
                  <a class="button" @click="handleChangeNetwork">
                    {{ $t('switcher.select') | capitalize }}
                    <span class="icon icon-arrow-long-right"></span>
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import User from '@/api/user';
import axios from '@/plugins/axios';
import EventBus from '@/events/event-bus';
import Loading from '@/components/Loading.vue';
import * as dataCache from '@/store/cache/dataCache';

export default {
  name: 'auth.switcher',
  components: { Loading },
  data() {
    return {
      loading: true,
      tenants: [],
      selectedTenantId: null,
      selectedNetworkId: null,
      networks_disabled: true,
      networks_loading: false,
      networks: [],
    };
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
    }),
  },
  watch: {
    user() {
    },
    selectedTenantId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.handleChangeTenant(newValue);
      }
    },
  },
  methods: {
    ...mapActions({
      resetCachedMap: 'map/resetMap',
    }),
    getTenants() {
      this.loading = true;
      User.getTenants(this.user.id)
        .then((response) => {
          this.tenants = response.data.sort((a, b) => a.name.localeCompare(b.name));
          this.selectedTenantId = this.user.primary_tenant_id;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChangeTenant(id) {
      axios.defaults.headers['x-tenant'] = id;
      this.$store.dispatch('switcher/setTenantId', this.selectedTenantId);
      this.selectedTenantId = id;
      this.networks_loading = true;
      this.loading = true;
      User.getNetwork(this.user.id)
        .then((response) => {
          this.networks = response.data;
          this.networks_loading = false;
          this.networks_disabled = false;
          this.selectedNetworkId = this.networks.length > 0 ? this.networks[0].id : null;
          this.$store.dispatch('switcher/setNetworkId', this.selectedNetworkId);
          axios.defaults.headers['x-network'] = this.selectedNetworkId;
        })
        .finally(() => {
          this.networks_loading = false;
          this.loading = false;
        });
    },
    async handleChangeNetwork() {
      this.loading = true;
      EventBus.$emit('ActionFilter.reset');
      EventBus.$emit('ActionSort.reset');
      dataCache.resetDataCache();
      axios.defaults.headers['x-network'] = this.selectedNetworkId;
      await this.$store.dispatch('switcher/setTenantId', this.selectedTenantId);
      await this.$store.dispatch('switcher/setNetworkId', this.selectedNetworkId);
      await this.resetCachedMap();
      EventBus.$emit('Map.clearMap');
      EventBus.$emit('Filter.reset');
      await this.$store.dispatch('settings/fetchNetwork');
      await this.$store.dispatch('settings/forceFetchAllNetwork');
      await this.$store.dispatch('selected/resetMapObject');
      await this.$store.dispatch('selected/resetSelection');
      await this.$store.dispatch('getUser');
      this.$emit('showFullscreen', false);
      await this.$router.push({ name: 'home' });
      this.loading = false;
    },
  },
  beforeMount() {
    this.$emit('showFullscreen', true);
  },
  mounted() {
    this.getTenants();
  },
};
</script>
